const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/demand/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
interface DemandBeforeLoadArgs {
  context: {
    flags: Partial<FlagKeys>;
  };
  params: {
    org: string;
  };
}
export const demandBeforeLoad = async ({
  context: {
    flags
  },
  params: {
    org
  }
}: DemandBeforeLoadArgs) => {
  if (!flags.newDemandViewEnabled) {
    throw redirect({
      to: '/org/$org',
      params: {
        org
      },
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/demand/')({
  staticData: {
    topNav: {
      title: i18n.t($ => $.demand.page.title)
    }
  },
  beforeLoad: demandBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});